export default {
  type: "object",
  label: "Estrutura de dados",
  shape: "square",
};
